import { RefObject, useEffect } from 'react'

function useOutsideClick<T extends HTMLElement>(el: RefObject<T | null>, onOutsideClick: () => void): void {
  useEffect(() => {
    if (!el) {
      return
    }

    const handleClick = (event: MouseEvent) => {
      if (el.current && !el.current.contains(event.target as Node)) {
        onOutsideClick()
      }
    }

    document.addEventListener('mousedown', handleClick)
    return () => {
      document.removeEventListener('mousedown', handleClick)
    }
  }, [el, onOutsideClick])
}

export default useOutsideClick
